var moduleMap = {
	"./UserProfile": () => {
		return Promise.all(/* __federation_expose_UserProfile */[__webpack_require__.e(143), __webpack_require__.e(443), __webpack_require__.e(775), __webpack_require__.e(718), __webpack_require__.e(21), __webpack_require__.e(517), __webpack_require__.e(260)]).then(() => (() => ((__webpack_require__(15807)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});